import { render, staticRenderFns } from "./my-password.vue?vue&type=template&id=1a7d59bf&scoped=true&"
import script from "./my-password.vue?vue&type=script&lang=js&"
export * from "./my-password.vue?vue&type=script&lang=js&"
import style0 from "./my-password.vue?vue&type=style&index=0&id=1a7d59bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7d59bf",
  null
  
)

export default component.exports